import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { RemoteImage } from '@gem/modules/remote-storage';

import FullScreenImage from 'APP/main/Popups/ContextPopups/FullScreenImage';
import { IImageResizerLocalStore } from 'APP/main/hooks/useImageResizer/useImageResizer';
import { TextPayload } from 'STORE/Messages/Message/Payload/TextPayload/TextPayload';

import styles from './ImagePreview.styles.m.css';

interface IImagePreviewProps {
  resizedImage: IImageResizerLocalStore;
  data: TextPayload['linkPreview'];
}

export const ImagePreview: FC<IImagePreviewProps> = observer(({ resizedImage, data }) => {
  return (
    <>
      {resizedImage.isShowFullScreen && (
        <FullScreenImage
          url={resizedImage.url}
          close={resizedImage.closeFullScreen}
        />
      )}
      <button
        onClick={resizedImage.openFullScreen}
        className={styles.container}
        style={resizedImage.containerStyle}
      >
        <RemoteImage
          width={resizedImage.imageSize.width}
          height={resizedImage.imageSize.height}
          className={styles.image}
          src={resizedImage.url}
          alt={data.title}
        />
      </button>
    </>
  );
});
